import { fromFetch } from 'rxjs/fetch';
import { FleetJwtAuthHeaders } from '../../models/fleet-jwt-auth-headers';
import { requiredHeaders } from '../../models/required-headers';
import { ignoreData } from '../../utils/ignore-data';
import { fleetEnvironment } from './fleet-environment';
import { ConfigurationProfile } from './schemas/configuration-profile.schema';

export function putConfigurationProfiles(
  configurationProfile: Partial<ConfigurationProfile>
) {
  return fromFetch(
    new Request(
      `${fleetEnvironment.configurationProfilesUrl}/${configurationProfile.id}`,
      {
        method: 'PUT',
        headers: {
          ...requiredHeaders,
          ...new FleetJwtAuthHeaders(),
        },
        body: JSON.stringify({
          ...configurationProfile,
        }),
      }
    )
  ).pipe(ignoreData());
}
